import { useEffect } from 'react';
import type { ScenarioCard } from '../data/types';
import { CATEGORY_LABELS } from '../data/types';
import styles from './Feedback.module.css';

interface FeedbackProps {
  card: ScenarioCard;
  userVerdict: 'green' | 'red';
  onNext: () => void;
}

export function Feedback({ card, userVerdict, onNext }: FeedbackProps) {
  // Auto-advance after 5 seconds; user can also tap Next
  useEffect(() => {
    const id = window.setTimeout(onNext, 5000);
    return () => window.clearTimeout(id);
  }, [card.id, onNext]);

  const correct =
    card.verdict === 'ambiguous' ? true : card.verdict === userVerdict;

  return (
    <section className={styles.box} role="status" aria-live="polite">
      <div className={`${styles.verdictRow} ${correct ? styles.right : styles.wrong}`}>
        <span className={styles.userPick}>
          you said: <strong>{userVerdict}</strong>
        </span>
        <span className={styles.actual}>
          actual:{' '}
          <strong>
            {card.verdict === 'ambiguous' ? 'ambiguous' : card.verdict + ' flag'}
          </strong>
        </span>
      </div>

      <p className={styles.category}>
        pattern: <span>{CATEGORY_LABELS[card.category]}</span>
      </p>

      <p className={styles.explanation}>{card.explanation}</p>

      {card.verdict === 'ambiguous' && (
        <p className={styles.ambiguousNote}>
          this card is genuinely ambiguous — either swipe is defensible. the
          lesson is the discomfort itself.
        </p>
      )}

      <button type="button" className={styles.next} onClick={onNext}>
        next →
      </button>
    </section>
  );
}
